import React from 'react'
import classnames from '@helpers/misc/classnames'

export default function Notice(props: {
  children: React.ReactNode
  level?: 'success' | 'error' | 'warning' | 'info'
  className?: string
}) {
  const {className = '', children, level = 'info'} = props
  return (
    <div
      className={classnames({
        'rounded px-4 py-3 text-sm': true,
        'bg-green-50 text-green-700': level === 'success',
        'bg-red-50 text-red-700': level === 'error',
        'bg-yellow-50 text-yellow-700': level === 'warning',
        'bg-sky-100 text-blue-700': level === 'info',
        [className]: true
      })}>
      {children}
    </div>
  )
}
